/* eslint-disable @typescript-eslint/naming-convention */
export enum WeekDayNumber {
    None = 'None',
    First = 'First',
    Second = 'Second',
    Third = 'Third',
    Fourth = 'Fourth'
}
